































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { GQL_newInvoiceData_newInvoice, GQL_newInvoiceData_newInvoice_orders_supplierParty } from '../../../../queries/__generated__/newInvoiceData';
import { isEqual, assign } from 'lodash';

@Component
export default class InvoiceSupplierPartyPicker extends Vue {
  public assign = assign;

  @Prop(Object) public invoice!: GQL_newInvoiceData_newInvoice;

  private get uniqueSupplierParties(): GQL_newInvoiceData_newInvoice_orders_supplierParty[] {
    const arr: GQL_newInvoiceData_newInvoice_orders_supplierParty[] = [];

    this.invoice.orders.forEach(order => {
      if (
        !arr.some(unique => isEqual(
          { ...order.supplierParty, id: null },
          { ...unique, id: null },
        ))
      ) {
        arr.push(order.supplierParty);
      }
    });

    return arr;
  }
}
